export const formatNumberWithCommas = strNum => {
  return parseFloat(strNum).toLocaleString('en-US');
}